import PageHeader, { LegalSection } from "@/components/PageHeader";
import { EMAILS } from "@/config";

export default function PrivacyPage() {
  return (
    <>
      <PageHeader
        testid="privacy-header"
        eyebrow="Gizlilik"
        titleLines={["Gizlilik", "Politikası."]}
        lede="Son güncelleme: [Tarih] — Bu sayfa, Five Star mobil uygulamasında kişisel verilerin nasıl işlendiğini açıklar."
      />
      <section className="bg-ivory pb-24 sm:pb-32 px-6">
        <div className="max-w-5xl mx-auto">
          <LegalSection index={1} title="Veri Sorumlusu">
            <p>
              Bu uygulama kapsamında veri sorumlusu: <strong>[Şirket / Veri Sorumlusu Bilgisi]</strong>
            </p>
            <p>
              İletişim: <a className="text-burgundy underline underline-offset-4 decoration-burgundy/30 hover:decoration-burgundy" href={`mailto:${EMAILS.privacy}`}>{EMAILS.privacy}</a>
            </p>
          </LegalSection>

          <LegalSection index={2} title="Toplanan Bilgiler">
            <p>Five Star, kişisel eşleşme deneyimini sunabilmek için aşağıdaki bilgi kategorilerini toplayabilir:</p>
            <ul className="list-disc pl-5 space-y-2">
              <li>Profil ve kayıt bilgileri (ad, yaş, şehir, tercihler)</li>
              <li>Fotoğraflar</li>
              <li>Mesajlaşma verileri</li>
              <li>Eşleşme tercihleri ve geri bildirimler</li>
              <li>Teknik cihaz verileri</li>
              <li>Bildirim tokenları</li>
              <li>Abonelik durumu</li>
            </ul>
          </LegalSection>

          <LegalSection index={3} title="Verilerin Kullanım Amaçları">
            <p>Toplanan bilgiler; eşleşme seçkilerinin hazırlanması, çöpçatan desteğinin sunulması, uygulamanın işletilmesi, güvenliğin sağlanması ve üyelik süreçlerinin yönetilmesi amaçlarıyla kullanılır.</p>
          </LegalSection>

          <LegalSection index={4} title="Hizmet Sağlayıcılar">
            <p>
              Uygulamanın işletilmesi için sınırlı sayıda hizmet sağlayıcıdan (örneğin barındırma ve bildirim altyapısı) destek alınabilir. Ayrıntılar: <strong>[Hizmet Sağlayıcı Bilgisi]</strong>
            </p>
          </LegalSection>

          <LegalSection index={5} title="Saklama Süreleri">
            <p>Kişisel veriler, hesabın aktif olduğu süre boyunca ve yürürlükteki mevzuatın gerektirdiği sürelerle sınırlı olarak saklanır.</p>
          </LegalSection>

          <LegalSection index={6} title="Hesap Silme">
            <p>
              Hesabını istediğin zaman uygulama içinden (Ayarlar → Hesabımı Sil) silebilirsin. Hesap silme süreci hakkında ayrıntılı bilgi için Hesap Silme sayfamızı inceleyebilirsin.
            </p>
          </LegalSection>

          <LegalSection index={7} title="Kullanıcı Hakları">
            <p>
              Kişisel verilerine erişme, düzeltilmesini veya silinmesini talep etme haklarına sahipsin. Taleplerin için <a className="text-burgundy underline underline-offset-4 decoration-burgundy/30 hover:decoration-burgundy" href={`mailto:${EMAILS.privacy}`}>{EMAILS.privacy}</a> adresine yazabilirsin.
            </p>
          </LegalSection>

          <LegalSection index={8} title="İletişim">
            <p>
              Gizlilikle ilgili tüm soruların için: <a className="text-burgundy underline underline-offset-4 decoration-burgundy/30 hover:decoration-burgundy" href={`mailto:${EMAILS.privacy}`}>{EMAILS.privacy}</a>
            </p>
          </LegalSection>
        </div>
      </section>
    </>
  );
}
